import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IQuestion, IQuestionChoice } from "../exam_papers/types";

// 문제 생성 요청 인터페이스
export interface ICreateQuestionRequest {
  exam_id: string;
  answer_type: string;
  category?: string;
  passage?: string;
  passage_id?: string;
  question: string;
  status?: string;
  choices?: IQuestionChoice[];
  correct_choice_id?: string;
}

/**
 * 문제 생성 API 함수
 * @param data 생성할 문제 데이터
 * @returns API 응답
 */
export const apiCreateQuestion = async (data: ICreateQuestionRequest) => {
  const response = await apiPost<IQuestion>("/questions", data);
  return response;
};

/**
 * 문제 생성 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useCreateQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateQuestion,
    onSuccess: (_, variables) => {
      // 문제 목록 데이터 갱신
      queryClient.invalidateQueries({ queryKey: QueryKeys.question.all });

      // 연관된 시험 데이터도 갱신 (시험 상세 정보의 문제 목록이 변경됨)
      if (variables.exam_id) {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.exam.detail(variables.exam_id),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.question.byExam(variables.exam_id),
        });
      }
    },
  });
};

export default useCreateQuestion;
